import { Postcode } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { PostcodeInput } from '@dreryk/react-components';

const POSTCODE_FIELD_NAME = 'postcode';

export type PostcodeFormBeanPart = {
   [POSTCODE_FIELD_NAME]: Postcode | null;
};

type PostcodeFieldProps = {
   readonly countryIsoCode: string | undefined;
   readonly register: BindingCreator<PostcodeFormBeanPart, typeof POSTCODE_FIELD_NAME>;
};

export const PostcodeField = (props: PostcodeFieldProps): JSX.Element => {
   return (
      <PostcodeInput
         controller={props.register(POSTCODE_FIELD_NAME, {
            required: true,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu react-components
             * i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: Postcode.MAX_LENGTH,
         })}
         countryIsoCode={props.countryIsoCode}
         testId={POSTCODE_FIELD_NAME}
      />
   );
};
